import { jsxs as l, jsx as c } from "react/jsx-runtime";
const r = (h) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...h,
    children: [
      /* @__PURE__ */ c(
        "path",
        {
          fill: "currentColor",
          d: "M46.857 35.743c-6.138 0-11.114 4.975-11.114 11.114 0 6.139 4.975 11.114 11.114 11.114 6.139 0 11.114-4.975 11.114-11.114 0-6.139-4.975-11.114-11.114-11.114Zm0 19.23c-4.476 0-8.117-3.641-8.117-8.117 0-4.476 3.641-8.117 8.117-8.117 4.476 0 8.117 3.641 8.117 8.117 0 4.476-3.641 8.117-8.117 8.117Z"
        }
      ),
      /* @__PURE__ */ c(
        "path",
        {
          fill: "currentColor",
          d: "M51.893 45.85h-4.029v-4.03l-2.015.54v3.489h-4.03l.54 2.015h3.489v4.029h2.015v-4.029h4.029v-2.015l.001.001ZM38.763 36.549l-2.356-.143c0 1.549-1.102 2.547-2.547 2.547h-4.51c1.549-1.033 2.135-2.685 2.135-4.303 0-.207 0-.414-.034-.619h4.854v-3.787h-6.059c-.345-.895-.585-1.687-.585-2.72 0-1.825 1.274-2.685 2.651-2.685 1.79 0 2.754 1.205 2.789 3.304l4.51-1.205c-.172-2.823-2.066-6.369-7.367-6.369-4.82 0-7.574 3.408-7.574 6.783 0 1.137.172 2.066.448 2.892h-1.962v3.787h3.339c.069.379.138.757.138 1.136 0 2.031-1.411 3.442-3.58 4.2v4.062h11.153a13.144 13.144 0 0 1 4.562-6.88h-.005Z"
        }
      ),
      /* @__PURE__ */ c(
        "path",
        {
          fill: "currentColor",
          d: "M35.66 53.672a22.145 22.145 0 0 1-3.66.304c-2.969 0-5.846-.58-8.553-1.725a21.929 21.929 0 0 1-6.986-4.711 21.885 21.885 0 0 1-6.436-15.538c0-2.968.58-5.846 1.725-8.553a21.918 21.918 0 0 1 4.711-6.986A21.885 21.885 0 0 1 32 10.027c2.969 0 5.845.58 8.552 1.725a21.918 21.918 0 0 1 6.986 4.711 21.896 21.896 0 0 1 6.436 15.539c0 1.238-.103 2.459-.303 3.66a13.201 13.201 0 0 1 3.429 3.024c.566-2.133.87-4.372.87-6.684 0-14.343-11.628-25.971-25.971-25.971S6.028 17.656 6.028 31.999 17.656 57.97 31.999 57.97c2.311 0 4.551-.304 6.684-.87a13.24 13.24 0 0 1-3.024-3.429h.001v.001Z"
        }
      )
    ]
  }
);
export {
  r as TopUp
};
